import React from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { useIntl } from "react-intl";
import { isAllowedFeature } from "../../organization/organizationSlice";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";

const Details = (props) => {
  const intl = useIntl();
  return (
    <ChildrenAnimationWrapper>
      <Row>
        <Col span={11}>
          <AnimationChildWrapper itemKey={1}>
            <InputItem name="name" required={true} category="branch" />
          </AnimationChildWrapper>

          <AnimationChildWrapper itemKey={2}>
            <PhoneNumberItem name="phone_number" category="branch" />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={3}>
            <InputItem
              number={true}
              required={true}
              name="btl_accounting_number"
              category="branch"
              placeholder={intl.formatMessage({
                id: "app.forms.branch.btl_number_placeholder",
              })}
            />
          </AnimationChildWrapper>
          {isAllowedFeature("accounting_tag") && (
            <InputItem
              number={true}
              required={true}
              name="accounting_number_tag"
              category="branch"
              placeholder={intl.formatMessage({
                id: "app.forms.branch.accounting_number_tag",
              })}
              oneToNinetyNineNumbers={true}
            />
          )}
        </Col>
        <Col span={11} offset={2}>
          <AnimationChildWrapper itemKey={4}>
            <PhoneNumberItem name="mobile_number" category="branch" />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={5}>
            <InputItem name="email" email={true} category="branch" />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={6}>
            <InputItem required={true} name="salary_id" category="branch" />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={6}>
            <SettingsDataSelect
              name="group_id"
              category="branch"
              settingsdataName={"system_tables/branch_groups"}
              required={process.env.REACT_APP_CONFIG === "matav"}
            />
          </AnimationChildWrapper>
        </Col>
      </Row>
    </ChildrenAnimationWrapper>
  );
};

export default Details;
